import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface PersonnelData {
  total: number;
  present: number;
  onLeave: number;
  sickLeave: number;
  absent: number;
}

interface TeamPersonnelProps {
  data?: PersonnelData;
  isLoading?: boolean;
}

export function TeamPersonnel({ data, isLoading }: TeamPersonnelProps) {
  const stats = data || {
    total: 12,
    present: 10,
    onLeave: 1,
    sickLeave: 1,
    absent: 2
  };

  const calculatePercent = (val: number) => Math.round((val / stats.total) * 100);

  return (
    <Card className="border-none shadow-sm h-full">
      <CardContent className="p-6">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Nhân sự tổ</h3>

        <div className="flex items-center gap-6">
          {/* Donut Chart Mockup */}
          <div className="relative w-28 h-28 shrink-0">
            <svg className="w-full h-full" viewBox="0 0 36 36">
              <circle cx="18" cy="18" r="16" fill="none" className="stroke-slate-100" strokeWidth="4" />
              <circle 
                cx="18" cy="18" r="16" fill="none" 
                className="stroke-emerald-600" 
                strokeWidth="4" 
                strokeDasharray={`${calculatePercent(stats.present)} 100`} 
                strokeLinecap="round"
                transform="rotate(-90 18 18)"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-xl font-black text-slate-800">{stats.total}</span>
              <span className="text-[10px] font-bold text-slate-400">Tổng số</span>
            </div>
          </div>

          <div className="flex-1 space-y-3">
            <LegendItem color="bg-emerald-600" label="Có mặt" value={stats.present} percent={calculatePercent(stats.present)} />
            <LegendItem color="bg-blue-500" label="Nghỉ phép" value={stats.onLeave} percent={calculatePercent(stats.onLeave)} />
            <LegendItem color="bg-orange-400" label="Nghỉ ốm" value={stats.sickLeave} percent={calculatePercent(stats.sickLeave)} />
            <LegendItem color="bg-slate-300" label="Vắng" value={stats.absent} percent={calculatePercent(stats.absent)} />
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-emerald-600 flex items-center gap-2 hover:underline">
            <i className="ri-user-search-line text-sm" />
            Xem chi tiết nhân sự
          </button>
        </div>
      </CardContent>
    </Card>
  );
}

function LegendItem({ color, label, value, percent }: { color: string, label: string, value: number, percent: number }) {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${color}`} />
        <span className="text-[10px] font-bold text-slate-500">{label}</span>
      </div>
      <span className="text-[10px] font-bold text-slate-800">{value} ({percent}%)</span>
    </div>
  );
}
